<template>
  <div class="page-module-wrap">
    <!-- 搜索头部分 start -->
    <div class="search">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div class="section-gap">
            <div class="block">
              <button class="button is-info width-1" @click="onAdd">添加快捷回复</button>
              <button class="button is-success width-1" @click="onSubmit">提交</button>
            </div>
          </div>
        </article>
      </div>
    </div>
    <!-- 搜索头部分 end -->
    <!-- 列表部分 start -->
    <div class="list-wrap">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <table class="table is-bordered">
            <thead>
            <tr>
              <th>序号</th>
              <th>关键词</th>
              <th>快捷回复</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in list">
              <td>{{index+1}}</td>
              <td>
                <input type="text" class="input" v-model="item.replyTag">
              </td>
              <td>
                <input type="text" class="input" v-model="item.reply">
              </td>
            </tr>
            </tbody>
          </table>
        </article>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
  export default {
    data(){
      return {
        list:[],
        isIcy:0
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.isIcy = this.$route.query.isIcy ? 1 : 0
        this.getList()
      })
    },
    methods:{
      getList(){
        let params = {
          isIcyBusinessUserId : this.isIcy
        }
        HttpRequest.post('/admin.php?method=agencyoperation.showCommonReply',params).then(response => {
          this.list = _.toArray(response.data)
        })
      },
      onAdd(){
        this.list.push({
          replyTag:`快捷回复${this.list.length+1}`,
          reply:''
        })
      },
      onSubmit(){
        let replyTag = [],reply = []
        _.each(this.list,(item,index)=>{
          replyTag.push(item.replyTag)
          reply.push(item.reply)
        })
        let params = {
          isIcyBusinessUserId:this.isIcy,
          replyTag:replyTag,
          reply:reply
        }
        HttpRequest.post('/admin.php?method=agencyoperation.doSaveCommonReply',params).then(response => {
          if(response.data.result){
            this.$message('保存成功!')
          }
        })
      },
    }
  }
</script>
<style lang="less">

</style>
